import { render, staticRenderFns } from "./OnlineCourses.vue?vue&type=template&id=777afad7&scoped=true"
import script from "./OnlineCourses.vue?vue&type=script&lang=js"
export * from "./OnlineCourses.vue?vue&type=script&lang=js"
import style0 from "./OnlineCourses.vue?vue&type=style&index=0&id=777afad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777afad7",
  null
  
)

export default component.exports